<template>
  <div>
    <img :src="url" alt="" class="qrimg" />
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      url: "",
    };
  },
  mounted() {
    var code = this.$route.params.code;
    code = window.atob(code);
    this.url = "https://weapp-cdn.gongjiayun.cn/images/dcqrcode2/" + code;
  },
  methods: {
    hexToString(str) {
      return eval("0x" + str);
    },
  },
};
</script>

<style lang="css" scoped>
.qrimg {
  width: 80%;
  display: block;
  margin: 50px auto;
}
</style>